// Asegúrate de importar los tipos adecuados
// import { EmptyFields, InputData } from "../../interfaces/interfaces.interfaces";

export const validateData = (values, optional = []) => {
    let allValid = true;
    const errors = {};

    for (const key in values) {
        // Verificamos si la clave actual no está en `optional`
        if (!optional.includes(key)) {
            if (
                values[key] === "" ||
                values[key] === undefined ||
                values[key] === null
            ) {
                errors[key] = "required";
                allValid = false;
            }
        } else {
            errors[key] = "";
        }
    }

    return { status: allValid, emptyFields: errors };
};
